export default __webpack_public_path__ + "static/media/LandingArrow.cdf66729.svg";